import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ProfilePopoverPage } from './profilepopover.page';

const routes: Routes = [
  {
        path: '',
        component: ProfilePopoverPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
    ],
    declarations: [ProfilePopoverPage],
    entryComponents: [ProfilePopoverPage]
})
export class ProfilePopoverPageModule {}
